import React from "react";
import { formatDate, downloadReport } from "../../util/functions";
import style from "./style.module.css"
import styleButton from '../../components/Button/Button.module.css'
import Logo from "../Logo";

const PrintPage = props => {
  const { children, signed_by, has_logo, header } = props;

  return (
    <div className={style.print_page}>
      <div className={style.print_header}>
        {!!header && (
          <span className={`-show-on-print ${style.header}`} style={{ float: "right" }}>
            {header}
          </span>
        )}
        {has_logo && (
          <span className="-show-on-print" style={{ float: "right" }}>
            <Logo />
          </span>
        )}
      </div>
      {children}
      <div className={`${style.sign} -show-on-print op-5`}>
        {!!signed_by && (
          <p className="mt-5 mb-1">{`Relatório Gerado por ${signed_by}`}</p>
        )}
        <p>{formatDate(new Date(), 4)}</p>
      </div>
    </div>
  )
}

const PrintButton = props => {
  const { label } = props;
  return (
    <button
      type="button"
      className={`${styleButton.button_primary} ml-3 -hide-on-print`}
      onClick={() => {
        window.print();
      }}
    >
      <span>{label}</span>
    </button>
  )
}

const CSVButton = props => {
  const { label, overview, table, filter, title, signed_by, has_subgroups = false } = props;
  return (
    <button
      type="button"
      className={`${styleButton.button_primary} ml-3 -hide-on-print`}
      onClick={() => {
        let _table2print = [
          ["--- VISÃO GERAL ---"],
          [""],
          [title],
          [""],
        ];
        overview.forEach(e => {
          _table2print.push([e.label, e.value])
        })
        _table2print.push([""], [""]);
        if (!has_subgroups) {
          _table2print.push(["--- DADOS ---"], [""]);
          let _labels = [];
          !!table.length && Object.keys(table[0]).forEach(e => {
            if (e !== "color" && e !== "is_class") {
              _labels.push([e])
            }
          })
          _table2print.push(_labels);
          _table2print.push([""]);
          table.forEach(__table2print => {
            delete __table2print.color;
            delete __table2print.is_class;
            _table2print.push(Object.values(__table2print).map(__value => __value || ""))
          })
          _table2print.push([""], [""]);
        }
        else {

        }
        let _filter_labels = [];
        Object.keys(filter).forEach(__key => {
          _filter_labels.push([__key])
        })
        let _filter_values = [];
        Object.values(filter).forEach(__key => {
          if (__key === null || __key === "") {
            _filter_values.push(["-"]);
          }
          else if (Array.isArray(__key)) {
            let _array_to_string = "";
            __key.forEach((__value, __value_i) => {
              _array_to_string += `${!!__value_i ? ', ' : ''}${__value}`
            })
            _filter_values.push(`"${_array_to_string}"`);
          }
          else if (typeof __key?.getMonth === "function") {
            _filter_values.push([formatDate(new Date(__key), 2)]);
          }
          else if (typeof __key === "object") {
            _filter_values.push([__key.label]);
          }
          else {
            _filter_values.push([__key]);
          }
        })
        _table2print.push(["--- FILTRO ---"], [""]);
        _table2print.push(_filter_labels);
        _table2print.push([""]);
        _table2print.push(_filter_values);
        _table2print.push([""], [""], ["--- RODAPÉ ---"], [""]);
        _table2print.push([`Relatório Gerado por ${signed_by}`]);
        _table2print.push([formatDate(new Date(), 4)]);
        downloadReport(_table2print, `relatorio-comercial-${title}`);
      }}
    >
      <span>{label}</span>
    </button>
  )
}

PrintPage.PrintButton = PrintButton;
PrintPage.CSVButton = CSVButton;


export { PrintPage };